<template>
	<div>
		<!-- Filters -->
		<bidders-list-filters
			:options="options"
			:business-areas-filter.sync="businessAreasFilter"
			:approval-states-filter.sync="approvalStatesFilter"
		/>

		<!-- Table Container Card -->
		<b-card
			no-body
			class="mb-0"
		>
			<div class="m-2">
				<!-- Table Top -->
				<b-row>
					<!-- Per Page -->
					<b-col
						cols="12"
						md="4"
						class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
					>
						<label>Mostrar</label>
						<v-select
							v-model="perPage"
							:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
							:options="perPageOptions"
							:clearable="false"
							class="per-page-selector d-inline-block mx-50"
						/>
						<label>registros</label>
					</b-col>

					<!-- Search -->
					<b-col
						cols="12"
						md="6"
						class="ml-auto"
					>
						<div class="d-flex">
							<b-form-input
								v-model="searchQuery"
								class="d-inline-block mr-1"
								placeholder="Buscar ..."
								trim
							/>
							<b-button
								:to="{ name: 'bidders-create' }"
								variant="primary"
							>
								<span class="text-nowrap">Nuevo Postor</span>
							</b-button>
						</div>
					</b-col>
				</b-row>
			</div>

			<b-table
				ref="refBidderListTable"
				class="position-relative table-bidders"
				:style="totalBidders >= 1 && totalBidders <= 3 ? 'height: 280px' : 'height: inherit'"
				:items="fetchBidders"
				responsive
				:fields="tableColumns"
				primary-key="id2"
				:sort-by.sync="sortBy"
				show-empty
				empty-text="No se encontraron registros coincidentes"
				:sort-desc.sync="isSortDirDesc"
			>
				<template #table-busy>
					<div class="text-center text-primary my-2">
						<b-spinner class="align-middle mb-1"></b-spinner>
						<div>
							<b>CARGANDO</b>
						</div>
					</div>
				</template>

				<template #head(approval_state_name)="data">
					<span v-html="data.label"></span>
				</template>

				<template #head(tender_count)="data">
					<span v-html="data.label"></span>
				</template>

				<template #cell(bidder_name)="data">
					<div style="width: 500px; text-transform: uppercase;">
						<b-media vertical-align="center">
							<template #aside>
								<b-avatar
									size="32"
									:src="null"
									:text="avatarText(data.item.bidder_name)"
									variant="light-success"
									:to="{ name: 'bidders-edit', params: { id: data.item.id } }"
								/>
							</template>
							<b-link
								:to="{ name: 'bidders-edit', params: { id: data.item.id } }"
								class="font-weight-bold d-block"
							>{{ data.item.bidder_name }}</b-link>
						</b-media>
					</div>
				</template>

				<template #cell(ruc)="data">
					<div class="text-nowrap">{{ data.item.ruc }}</div>
				</template>

				<template #cell(user_email)="data">
					<div class="text-nowrap">{{ data.item.user_email }}</div>
					<!-- <div class="small text-muted">{{ data.item.user_alternate_email }}</div> -->
					<div class="small text-muted">{{ data.item.user_phone }}</div>
				</template>

				<template #cell(business_area_name)="data">
					<div class="text-nowrap">{{ data.item.business_area_name }}</div>
				</template>

				<template #cell(approval_state_name)="data">
					<div class="text-nowrap">
						<b-badge
							:variant="`light-${data.item.approval_state_color}`"
						>{{ data.item.approval_state_name }}</b-badge>
					</div>
				</template>

				<template #cell(tender_count)="data">
					<div class="text-nowrap">{{ data.item.tender_count }}</div>
				</template>

				<template #cell(actions)="data">
					<b-dropdown
						variant="link"
						no-caret
						:right="$store.state.appConfig.isRTL"
					>
						<template #button-content>
							<feather-icon
								icon="MoreVerticalIcon"
								size="16"
								class="align-middle text-body"
							/>
						</template>

						<b-dropdown-item @click="sendCredentials(data.item.id)">
							<feather-icon icon="MailIcon" />
							<span class="align-middle ml-50">Reenviar Credenciales</span>
						</b-dropdown-item>

						<b-dropdown-item :to="{ name: 'bidders-edit', params: { id: data.item.id } }">
							<feather-icon icon="EditIcon" />
							<span class="align-middle ml-50">Editar</span>
						</b-dropdown-item>

						<b-dropdown-item
							v-if="data.item.certificate_path"
							@click="viewCertificate(data.item.id)"
						>
							<feather-icon icon="DownloadIcon" />
							<span class="align-middle ml-50">Descargar certificado IH</span>
						</b-dropdown-item>

						<b-dropdown-item @click="deleteBidder(data.item.id)">
							<feather-icon icon="TrashIcon" />
							<span class="align-middle ml-50">Eliminar</span>
						</b-dropdown-item>
					</b-dropdown>
				</template>
			</b-table>

			<div class="mx-2 mb-2">
				<b-row>
					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-start"
					>
						<span
							class="text-muted"
						>Mostrando {{ dataMeta.from }} al {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
					</b-col>

					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-end"
					>
						<b-pagination
							v-model="currentPage"
							:total-rows="totalBidders"
							:per-page="perPage"
							first-number
							last-number
							class="mb-0 mt-1 mt-sm-0"
							prev-class="prev-item"
							next-class="next-item"
						>
							<template #prev-text>
								<feather-icon
									icon="ChevronLeftIcon"
									size="18"
								/>
							</template>
							<template #next-text>
								<feather-icon
									icon="ChevronRightIcon"
									size="18"
								/>
							</template>
						</b-pagination>
					</b-col>
				</b-row>
			</div>
		</b-card>
	</div>
</template>

<script>
import { ref, onBeforeMount, onUnmounted } from "@vue/composition-api"
import BiddersListFilters from "./BiddersListFilters.vue"
import bidderStoreModule from "../bidderStoreModule"
import useBiddersList from "./useBiddersList"
import { avatarText } from "@core/utils/filter"
import VueSweetalert2 from "vue-sweetalert2"
import useNotifications from "@notifications"
import vSelect from "vue-select"
import store from "@/store"
import moment from "moment"
import axios from "@axios"
import Vue from "vue"
import "animate.css"

Vue.use(VueSweetalert2)

export default {
	components: {
		BiddersListFilters,
		vSelect
	},
	data() {
		return {
			moment
		}
	},
	setup() {
		// USE TOAST
		const { swalNotification, toastNotification } = useNotifications()

		// REFS
		const options = ref({})

		const BIDDER_APP_STORE_MODULE_NAME = "app-bidder"

		// REGISTER MODULE
		if (!store.hasModule(BIDDER_APP_STORE_MODULE_NAME))
			store.registerModule(BIDDER_APP_STORE_MODULE_NAME, bidderStoreModule)

		// UNREGISTER ON LEAVE
		onUnmounted(() => {
			if (store.hasModule(BIDDER_APP_STORE_MODULE_NAME))
				store.unregisterModule(BIDDER_APP_STORE_MODULE_NAME)
		})

		// CALL FUNCTION TO POPULATE OPTIONS FOR THE FILTERS
		onBeforeMount(() => {
			getSelectFilters()
		})

		const getSelectFilters = async () => {
			try {
				const response1 = await axios.get("/selectors/business-areas")
				const response2 = await axios.get("/selectors/approval-states")

				options.value = {
					...response1.data,
					...response2.data
				}
			} catch (error) {
				toastNotification(error.response.data.message, false)
			}
		}

		const viewCertificate = (id) => {
			store
				.dispatch("app-bidder/viewCertificate", { id })
				.then((response) => window.open(response.data.url, "_blank"))
				.catch(() =>
					toastNotification("Error al descargar el certificado de IH.", false)
				)
		}

		const deleteBidder = (id) => {
			Vue.swal({
				title: "¿Está seguro(a) de eliminar el postor?",
				html: "<small>¡Si no lo está, puede cancelar la acción!</small>",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Sí, eliminar!",
				cancelButtonText: "Cancelar",
				customClass: {
					confirmButton: "btn btn-primary",
					cancelButton: "btn btn-outline-danger ml-1"
				},
				showClass: {
					popup: "animate__animated animate__tada"
				},
				buttonsStyling: false
			}).then((result) => {
				if (result.value) {
					store
						.dispatch("app-bidder/deleteBidder", { id })
						.then((response) => {
							refetchData()
							swalNotification(response.data.message)
						})
						.catch((error) => {
							const message =
								error.response.data.message || "Error al eliminar el postor."
							swalNotification(message, false)
						})
				}
			})
		}

		const sendCredentials = (id) => {
			store
				.dispatch("app-bidder/resendCredentials", { id })
				.then((response) => {
					swalNotification(response.data.message)
				})
				.catch((error) => {
					const message =
						error.response.data.message ||
						"Error al enviar las creedenciales al postor."
					swalNotification(message, false)
				})
		}

		const {
			fetchBidders,
			tableColumns,
			perPage,
			currentPage,
			totalBidders,
			dataMeta,
			perPageOptions,
			searchQuery,
			sortBy,
			isSortDirDesc,
			refBidderListTable,
			refetchData,

			// EXTRA FILTERS
			businessAreasFilter,
			approvalStatesFilter
		} = useBiddersList()

		return {
			fetchBidders,
			tableColumns,
			options,
			perPage,
			currentPage,
			totalBidders,
			dataMeta,
			perPageOptions,
			searchQuery,
			sortBy,
			isSortDirDesc,
			refBidderListTable,
			refetchData,

			// EXTRA FILTERS
			businessAreasFilter,
			approvalStatesFilter,

			// ACTIONS
			avatarText,
			viewCertificate,
			deleteBidder,
			sendCredentials
		}
	}
}
</script>

<style lang="scss" scoped>
.media {
	align-items: center;
}

.per-page-selector {
	width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-sweetalert.scss";
</style>